export default __webpack_public_path__ + "images/PA.27b6cba.png";